import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import strings from '../../components/locales/';
import { Tooltip } from 'react-bootstrap';
import toastr from 'toastr';
import $ from 'jquery';
import constant from '../function/constants';

/* Function */
import ObjGeneral from '../function/';
/* Local store */
import { localStoreFN } from '../../store/localStorage';
/* Actions */
import * as flowAdminActions from '../../actions/flow_admin_detail/index';
import * as accountDriverActions from '../../actions/account_driver/index';
import * as accountSemiTrailerActions from '../../actions/account_semi_trailer/index';
import * as accountVehicleActions from '../../actions/account_vehicle/index';
import * as dynamicListActions from '../../actions/dynamic_list';

/* Components */
import FlowsTable from '../../components/flow_admin_detail/flowsTable';
import TodayFlowsStatsBlock from '../../components/flow_admin_detail/todayFlowsStatsBlock';
import TopTableButtons from '../../components/flow_admin_detail/topTableButtons';
import BottomTableButtons from '../../components/flow_admin_detail/bottomTableButtons';
import ModalEdit from '../../components/flow_admin_detail/modalEdit';
import ModalComments from '../../components/flow_admin_detail/modalComments';
import ModalViewComments from '../../components/flow_admin_detail/modalViewComments';
import ModalTodayReport from '../../components/flow_admin_detail/modalTodayReport';
import Loading from '../../components/common/loading';
import Message from '../../components/common/message';
import Expired from '../expired/index';

class FlowAdminDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModalEdit: false,
      selectedFlow: null,
      selectedAction: null,
      showModalComments: false,     
      showModalViewComments: false,      
      showModalTodayReport: false,
      viewComments: "",
      actionComments: "",
      refreshTime: 60000 * 10, //10min
      refreshIntervalObject: null,
      pendingStatsToSave: false,
      statsInputs: {
        morningFlowsInput: "",
        dayFlowsAscendsInput: 0,
        dayFlowsDescendsInput: 0,
        dayFlowsInformedDescendsInput: 0,
      },
      statsTotals: {
        morningFlows: 0,
        dayFlows: 0,
        totalFlows: 0,
        flowsLeft: 0,
        morningFlowsPlannedYesterday: 0
      },
      statsSaveTimeoutObject: null,
      listsByName: {}
    };
  }

  componentWillUnmount() {
    this.props.actions.reset();
    if(this.state.refreshIntervalObject != null) {
      clearInterval(this.state.refreshIntervalObject);
    }
  }

  async componentDidMount() {
    const permits = localStoreFN().getItem('permits');
    const permit = permits.includes('flowrequestsadmin');

    if (permit) {
      if (this.props.setting) {
        const obj = JSON.parse(this.props.setting.value);

        if (obj.generalSetting.views.includes('flowrequests')) {
          await this.props.accountVehicleActions.fetchAccountVehicleApi({            
            see: true
          });
          await this.props.accountSemiTrailerActions.fetchAccountSemiTrailerExtendedPropertiesApi({});         
          await this.props.accountSemiTrailerActions.fetchAccountSemiTrailerApi({            
            see: true
          });          
          await this.props.accountDriverActions.fetchAccountDriverApi({            
            see: true
          });
          await this.props.dynamicListActions.getAllListWithItems({});
          await this.props.actions.fetchFlowAdminDetailApi({});
          this.state.refreshIntervalObject = setInterval(
            (function() {
              if(!this.state.showModalEdit 
                && !this.state.showModalComments
                && !this.state.pendingStatsToSave){
                this.props.actions.backgroundFetchFlowAdminDetailApi({});
              }
            }).bind(this),
            this.state.refreshTime
          );         
        } else {
          this.props.history.push('/dashboard/authorization');
        }
      }
    } else {
      this.props.history.push('/dashboard/authorization');
    }
  }

  //Manage redux state changes
  async componentDidUpdate(prevProps) {
    toastr.options = constant.tostrOptions;
    //map lists by name
    if (prevProps.lists.loading == true 
      && this.props.lists.loading == false
      && this.props.lists.status === 200) {      
      this.props.lists.datos.map((item) => {
        this.state.listsByName[item.name.toUpperCase()] = item;
      });
    }

    //flow edit validation ok, so, display comments
    if (prevProps.validateFlow.loading == true 
      && this.props.validateFlow.loading == false
      && this.props.validateFlow.status == 200) {
      this.setState({
        showModalComments: true,
        actionComments: "",
        showModalEdit: false
      });      
    }

    //save flow actions manage result behavior
    if (prevProps.saveFlowActions.loading == true 
      && this.props.saveFlowActions.loading == false
      && this.props.saveFlowActions.status === 200) {      
      await this.props.actions.backgroundFetchFlowAdminDetailApi({});
      toastr.success(
        "Los cambios fueron guardados y enviados con exito.",
        "Información"
      );
    }
    else if (prevProps.saveFlowActions.loading == true 
      && this.props.saveFlowActions.loading == false
      && this.props.saveFlowActions.status !== 200) {      
      toastr.error(
        "Error al guardar cambios. Intentelo nuevamente.",
        "Error"
      );
    }

    //save stats manage result behavior
    if (prevProps.saveStats.loading == true 
      && this.props.saveStats.loading == false
      && this.props.saveStats.status === 200) {      
      toastr.success(
        "Los indicadores ingresados fueron guardados con exito.",
        "Información"
      );
    }
    else if (prevProps.saveStats.loading == true 
      && this.props.saveStats.loading == false
      && this.props.saveStats.status !== 200) {      
      toastr.error(
        "Error al guardar indicadores. Intentelo nuevamente re-escribiendo cualquiera de los indicadores.",
        "Error"
      );    
    }

    //set stats state from fetch
    if ((prevProps.backgroundFetch.loading == true 
      && this.props.backgroundFetch.loading == false
      && this.props.backgroundFetch.status === 200) ||
      (prevProps.loading == true 
      && this.props.loading == false
      && this.props.status === 200)) {
      this.setState({
        statsInputs: {
          morningFlowsInput: this.props.datos.stats.morningFlowsInput != null ? 
            this.props.datos.stats.morningFlowsInput : "",
          dayFlowsAscendsInput: this.props.datos.stats.dayFlowsAscendsInput != null ? 
            this.props.datos.stats.dayFlowsAscendsInput : 0,
          dayFlowsDescendsInput: this.props.datos.stats.dayFlowsDescendsInput != null ? 
            this.props.datos.stats.dayFlowsDescendsInput : 0,
          dayFlowsInformedDescendsInput: this.props.datos.stats.dayFlowsInformedDescendsInput != null ? 
            this.props.datos.stats.dayFlowsInformedDescendsInput : 0
        },
        statsTotals: {
          morningFlows: this.props.datos.stats.morningFlows,
          dayFlows: this.props.datos.stats.dayFlows,
          totalFlows: this.props.datos.stats.totalFlows,
          flowsLeft: this.props.datos.stats.flowsLeft,
          morningFlowsPlannedYesterday: this.props.datos.stats.morningFlowsPlannedYesterday
        }
      });             
    }
  }

  clearOverWeightFields = flowRequest => {
    if(flowRequest.vehicleType!="Sobredimensión") {
      flowRequest.mopPermit = "";
      flowRequest.mopPermitFiles = "";
      flowRequest.escort = "";
      delete flowRequest.mopPermitFilesNew;
    }
  };

  handleChangeFlowInput = e => {
    let selectedFlow = { ...this.state.selectedFlow };

    if(e.target.type=="file") {
      selectedFlow[e.target.dataset.update + "New"] = 
        document.getElementById(e.target.id).files;
      selectedFlow[e.target.dataset.update] = e.target.value;
    }
    else {
      selectedFlow[e.target.dataset.update] = e.target.value;
    }

    if(e.target.aliasValue) {
      selectedFlow[e.target.aliasValue.dataset.update] = e.target.aliasValue.value;
    }

    if(e.target.dataset.update=="vehicleType") {
      this.clearOverWeightFields(selectedFlow);
    }

    this.setState({
      selectedFlow
    });
  };

  handleClickEdit = e => {
    const modifiedFlow = JSON.parse(e.target.dataset.datos);
    const action = e.target.dataset.action;
    if(action == "clearState") {      
      this.props.actions.changeFlowAction(modifiedFlow, action, "");      
    }
    else {
      this.props.actions.validateFlowApiReset();      
      this.setState({
        showModalEdit: true,
        selectedFlow: modifiedFlow,
        selectedAction: action
      });
    }
  };

  handleCloseModalEdit = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalEdit: false,
        selectedFlow: null,
        selectedAction: null
      });
    }
  };

  handleValidateEdit = async e => {
    if(this.state.selectedFlow) {
      await this.props.actions.validateFlow({flowRequest: this.state.selectedFlow});
    }
  };

  handleChangeCommentsInput = e => {
    this.setState({
      actionComments: e.target.value
    });
  };

  handleUpdateActionWithComments = e => {
    this.props.actions.changeFlowAction(
      this.state.selectedFlow, 
      this.state.selectedAction, 
      this.state.actionComments);

    this.setState({
      showModalComments: false,
      selectedFlow: null,
      selectedAction: null,
      actionComments: ""
    });
  };

  handleCloseModalComments = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalComments: false,
        selectedFlow: null,
        selectedAction: null,
        actionComments: ""
      });
    }
  };

  handleCloseModalTodayReport = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalTodayReport: false
      });
    }
  };

  handleClickAccept = e => {
    const modifiedFlow = JSON.parse(e.target.dataset.datos);
    const action = e.target.dataset.action;
    this.props.actions.changeFlowAction(modifiedFlow, action, "");
  };

  handleClickReject = e => {
    const modifiedFlow = JSON.parse(e.target.dataset.datos);
    const action = e.target.dataset.action;
    if(action == "clearState") {      
      this.props.actions.changeFlowAction(modifiedFlow, action, "");      
    }
    else {
      this.setState({
        showModalComments: true,
        actionComments: "",
        selectedFlow: modifiedFlow,
        selectedAction: action
      });
    } 
  };

  handleChangeStatsInput = e => {
    const re = /^[0-9\b]+$/;
    if(e.target.value !== '' && !re.test(e.target.value)) {
      return;
    }

    let statsInputs = { ...this.state.statsInputs };
    let statsTotals = { ...this.state.statsTotals };
    let delta = e.target.value - statsInputs[e.target.dataset.update];
    let newValue = e.target.value;

    if(e.target.dataset.update == "morningFlowsInput" 
      && newValue == "") {
      delta = statsTotals.morningFlowsPlannedYesterday - statsInputs[e.target.dataset.update];
    }
    else if(e.target.dataset.update == "morningFlowsInput" 
      && newValue != "" && statsInputs[e.target.dataset.update]=="") {
      delta = newValue - statsTotals.morningFlowsPlannedYesterday;
    }

    statsTotals[e.target.dataset.updatetotal] += delta;
    statsTotals.totalFlows += delta;
    statsTotals.flowsLeft -= delta;
    statsInputs[e.target.dataset.update] = newValue;     

    this.setState({
      statsInputs: statsInputs,
      statsTotals: statsTotals,
      pendingStatsToSave: true
    });

    if(this.state.statsSaveTimeoutObject!=null) {
      clearTimeout(this.state.statsSaveTimeoutObject);      
    }
    this.state.statsSaveTimeoutObject = setTimeout(
      (function(){
        this.props.actions.saveStats({          
          morningFlowsInput: this.state.statsInputs.morningFlowsInput,
          dayFlowsAscendsInput: this.state.statsInputs.dayFlowsAscendsInput,
          dayFlowsDescendsInput: this.state.statsInputs.dayFlowsDescendsInput,
          dayFlowsInformedDescendsInput: this.state.statsInputs.dayFlowsInformedDescendsInput,
          totalFlows: this.state.statsTotals.totalFlows
        });
        this.state.statsSaveTimeoutObject = null;
        this.state.pendingStatsToSave = false;
      }).bind(this)
    ,3000);
  };

  handleSaveFlowActions = async e => {
    var flowsToSendArray = [];
    for (const prop in this.props.dataChanges) {
      flowsToSendArray.push(this.props.dataChanges[prop])
    }

    if(flowsToSendArray.length==0) {
      toastr.options = constant.tostrOptions;
      toastr.warning(
        "Debes resolver al menos una solicitud para enviar.",
        "Información"
      );
    }
    else {
      await this.props.actions.saveFlowActions(flowsToSendArray); 
    }
  };

  handleViewTodayReport = e => {
      this.setState({
        showModalTodayReport: true
      });
  };

  handleDownloadReports = async obj => {
    if(this.props.datos.stats 
      && (this.props.datos.stats.tomorrowMorningFlows>0
      || this.props.datos.stats.nightFlows>0)) {
      await this.props.actions.downloadTodayReport({});
    }
  };

  handleModalViewComments = e => {
      const comment = JSON.parse(e.target.dataset.datos);
      this.setState({
        showModalViewComments: true,
        viewComments: comment
      });
  };

  handleCloseModalViewComments = e => {
    if (e.target.dataset.close == 'ok') {
      this.setState({
        showModalViewComments: false,
        viewComments: ""
      });
    }
  };

  handleDownloadMopFile = async e => {
    const path = JSON.parse(e.target.dataset.path);
    await this.props.actions.downloadMopFile({
      path: path
    });
  };
  
  handleGetSemiTrailerType = semiTrailerId => {
    var type = "Desconocido";
    
    if(this.props.accountSemiTrailerDatos &&
      this.props.semiTrailerExtendedProperties) {
      var semiTrailerTypeIdProperty = null;

      this.props.semiTrailerExtendedProperties.map(prop => {
        if(prop.name.toUpperCase()=="TIPO") {
          semiTrailerTypeIdProperty = prop.id;
        }
      });

      this.props.accountSemiTrailerDatos.map(item => {
        if(item.id==semiTrailerId) {
          if(item.extendedProperties) {
            item.extendedProperties.map(property => {
              if(property.id==semiTrailerTypeIdProperty &&
                property.value)
              type = property.value;
            });
          }
        }
      });
    }
    return type;
  };

  render() {
    if (this.props.setting) {
      const obj = JSON.parse(this.props.setting.value);
      const setting = ObjGeneral.getSetting({
        setting: obj.tasksManager,
        filter: this.props.filter,
        general: obj.generalSetting
      });
      var  flowRequestCategory = null;
      const { graphColorRange } = obj;
      const language = this.props.language ? this.props.language : '';

      if(obj.flowRequestSettings 
        && obj.flowRequestSettings.flowRequestCategory) {
        flowRequestCategory = obj.flowRequestSettings.flowRequestCategory;
      }
      
      return (
        <section className="main flow-admin-detail">
          {(this.props.loading 
            || this.props.accountDriverLoading
            || this.props.accountVehicleLoading
            || this.props.accountSemiTrailerLoading
            || this.props.lists.loading) ? (
            <Loading language={this.props.language} />
          ) : (this.props.status === 401 
            || this.props.accountDriverStatus == 401
            || this.props.accountVehicleStatus == 401
            || this.props.accountSemiTrailerStatus == 401
            || this.props.lists.status == 401) ? (
            <Expired
              history={this.props.history}
              language={this.props.language ? this.props.language : ''}
            />
          ) : (this.props.status === 200 
            && this.props.accountDriverStatus == 200
            && this.props.accountVehicleStatus == 200
            && this.props.accountSemiTrailerStatus == 200
            && this.props.lists.status == 200) ? (
            <div className="main-container scroll">
              <TodayFlowsStatsBlock
        				language={this.props.language}
        				graphColorRange={graphColorRange}
        				className={"top-row"}
        				data={this.props.datos.stats}
                dataInputs={this.state.statsInputs}
                statsTotals={this.state.statsTotals}
                handleChange={this.handleChangeStatsInput}
                saveStats={this.props.saveStats.data}
              />
              <TopTableButtons
                language={this.props.language}
                className={"middle-row"}
                data={this.props.datos.stats}
                handleSaveFlowActions={this.handleSaveFlowActions}
                handleViewFlows={this.handleViewTodayReport}
                handleDownloadReports={this.handleDownloadReports}
              />
              <div className="table-row">
                <FlowsTable
                  data={this.props.datos.flowRequests}
                  dataChanges={this.props.dataChanges}
                  handleClickEdit={this.handleClickEdit}
                  handleClickAccept={this.handleClickAccept}
                  handleClickReject={this.handleClickReject}
                  handleModalViewComments={this.handleModalViewComments}
                  handleDownloadMopFile={this.handleDownloadMopFile}
                  language={this.props.language}
                />
                {(this.props.backgroundFetch.loading || this.props.saveFlowActions.loading) ? (
                  <div className="loading_dynamic_list table-loading-over">
                    <div className="lds-roller"><div/><div/><div/><div/><div/><div/><div/><div/></div>
                  </div>
                ):(null)}
              </div>
              <BottomTableButtons
                language={this.props.language}
                className={"bottom-row"}
                handleSaveFlowActions={this.handleSaveFlowActions}
              />
              <ModalEdit
                handleChange={this.handleChangeFlowInput}
                handleSubmit={this.handleValidateEdit}
                handleClose={this.handleCloseModalEdit}
                showModal={this.state.showModalEdit}
                selectedFlow={this.state.selectedFlow}
                validateFlow={this.props.validateFlow}
                language={this.props.language}
                drivers={this.props.accountDriverDatos}
                vehicles={this.props.accountVehicleDatos}
                semiTrailers={this.props.accountSemiTrailerDatos}
                lists={this.state.listsByName}
                getSemiTrailerType={this.handleGetSemiTrailerType}
                flowRequestCategory={flowRequestCategory}
              />
              <ModalComments
                handleChange={this.handleChangeCommentsInput}
                handleSubmit={this.handleUpdateActionWithComments}
                handleClose={this.handleCloseModalComments}
                showModal={this.state.showModalComments}
                comments={this.state.actionComments}
                language={this.props.language}
              />
              <ModalViewComments
                handleClose={this.handleCloseModalViewComments}
                showModal={this.state.showModalViewComments}
                comments={this.state.viewComments}
                language={this.props.language}
              />
              <ModalTodayReport
                handleClose={this.handleCloseModalTodayReport}
                showModal={this.state.showModalTodayReport}
                language={this.props.language}
                data={this.props.datos.stats}
              />
              <Tooltip placement="top" id="pageTooltip" />
            </div>
          ) : this.props.status === 500 
          || this.props.accountDriverStatus === 500
          || this.props.accountVehicleStatus === 500
          || this.props.accountSemiTrailerStatus === 500
          || this.props.lists.status === 500 ? (
            <Message message={this.props.language.error.apiError500} />
          ) : (
            <Message message={this.props.language.error.apiError} />
          )}
        </section>
      );
    } else {
      return (
        <section className="main">
          <Message message="NO Setting" />
        </section>
      );
    }
  }
}
const mapStateToProps = state => ({
  language: state.reducer.dashboard.language,
  setting: state.reducer.dashboard.setting,
  datos: state.reducer.flowAdminDetail.datos,
  dataChanges: state.reducer.flowAdminDetail.dataChanges,
  loading: state.reducer.flowAdminDetail.loading,
  status: state.reducer.flowAdminDetail.status,
  backgroundFetch: state.reducer.flowAdminDetail.backgroundFetch,
  validateFlow: state.reducer.flowAdminDetail.validateFlow,
  saveFlowActions: state.reducer.flowAdminDetail.saveFlowActions,
  saveStats: state.reducer.flowAdminDetail.saveStats,

  accountDriverDatos: state.reducer.accountDriver.datos,
  accountDriverStatus: state.reducer.accountDriver.status,
  accountDriverLoading: state.reducer.accountDriver.loading,

  accountVehicleDatos: state.reducer.accountVehicle.datos,
  accountVehicleStatus: state.reducer.accountVehicle.status,
  accountVehicleLoading: state.reducer.accountVehicle.loading,

  accountSemiTrailerDatos: state.reducer.accountSemiTrailer.datos,
  accountSemiTrailerStatus: state.reducer.accountSemiTrailer.status,
  accountSemiTrailerLoading: state.reducer.accountSemiTrailer.loading,
  semiTrailerExtendedProperties: state.reducer.accountSemiTrailer.extendedProperties,

  lists: state.reducer.dynamicList.lists,
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(flowAdminActions, dispatch),
  accountDriverActions: bindActionCreators(accountDriverActions, dispatch),
  accountVehicleActions: bindActionCreators(accountVehicleActions, dispatch),
  accountSemiTrailerActions: bindActionCreators(accountSemiTrailerActions, dispatch),  
  dynamicListActions: bindActionCreators(dynamicListActions, dispatch)
});
FlowAdminDetail.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(FlowAdminDetail);



// WEBPACK FOOTER //
// ./source/client/containers/flow_admin_detail/index.jsx